import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import '../../../css/buttons.css';
import { rcsClickTrackingURL, rcsTrack } from '../../../functions/rcsTrack';
import AddButton from './AddButton';

const ButtonGroup = ({
  quantity,
  decrementFunction,
  incrementFunction,
  disableBtn,
  disableIncrement,
  isHome = false,
  itemId,
  initiateRcsTrack = false,
  clickTrackingURL = '',
  from = '',
}) => {
  const { t } = useTranslation();

  const { bestSellerItems } = useSelector((state) => state.recommendations);

  const addToCartHandler = () => {
    let clickTrackingURLFromMenuItem;
    if (!clickTrackingURL) {
      clickTrackingURLFromMenuItem =
        bestSellerItems.find((item) => item.id === itemId)?.clickTrackingURL || '';
    }
    if (initiateRcsTrack) {
      const finalClickTrackingURL = clickTrackingURL || clickTrackingURLFromMenuItem;
      if (finalClickTrackingURL) {
        rcsClickTrackingURL(finalClickTrackingURL);
      }
      rcsTrack('itemPage', { itemId });
      setTimeout(() => {
        rcsTrack('addToCartPage', { atcid: itemId, tag: !!clickTrackingURL ? 'bestseller' : '' });
      }, 500);
    }
    incrementFunction();
  };
  return (
    <>
      {quantity > 0 && (
        <div
          className={`btnGroup addButtonIncrease ${
            isHome || from === 'menu' || from === 'search' ? 'add-button-home' : ''
          } align-items-center`}>
          <button
            disabled={disableBtn}
            type='button'
            className='fw-500 fs-20 btn plusMinus'
            onClick={decrementFunction}>
            &#8722;
          </button>
          <button
            type='button'
            className={`fw-500 btn ${
              isHome || from === 'menu' || from === 'search' ? 'plusMinus' : ''
            } itemQuantity`}>
            {quantity}
          </button>
          <button
            disabled={disableBtn}
            type='button'
            className={`fw-500 fs-20 btn plusMinus ${disableIncrement ? 'grey' : ''}`}
            onClick={incrementFunction}>
            +
          </button>
        </div>
      )}
      {!quantity && (
        <AddButton disableBtn={disableBtn} btnText={t('Add')} btnFunction={addToCartHandler} />
      )}
    </>
  );
};

export default ButtonGroup;
